// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"48":"result-page","79":"processing-static-page","185":"widget-page","285":"redirect-page"}[chunkId] || chunkId) + "." + {"48":"3c7af7cd","79":"6b55c17c","109":"ad204922","185":"f4928bda","285":"7c567a04","683":"ebfb2896","974":"67172ae8"}[chunkId] + ".js";
};